// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"6800ec3e","213":"3d47f36d","588":"49feabfd","787":"4b71f460","933":"4924ca78"}[chunkId] + ".chunk.js";
};